import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'

export const alerts = [
  {
    path: '/alerts',
    name: ERouterList.ALERTS,
    component: () => import('@internal/pages/alerts/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/alerts/:alertId',
    name: ERouterList.ALERT,
    component: () => import('@internal/pages/alerts/_alertId/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/alerts/:alertId/:taskId',
    name: ERouterList.ALERT_COMPLETE_TASK,
    component: () => import('@internal/pages/alerts/_alertId/_taskId/complete.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/alerts/:alertId/:taskId',
    name: ERouterList.ALERT_CANCEL_TASK,
    component: () => import('@internal/pages/alerts/_alertId/_taskId/cancel.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
]

export default alerts
